/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-08-16 09:43:01
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-02-26 18:17:07
 * @FilePath: \baishu_react_ui\src\Login\LoginWorkWechatCode\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, {Component} from 'react';
import qiyeweixin from '../../images/img_qiyeweixin@2x.png'
import convert from '../../images/ic_zhuanhuan@2x.png'
import './index.css'

class LoginWorkWechatCode extends Component {
    state={
        CORP_TYPE:window.sitesetting.CORP_TYPE
    }
    render() {
        const {CORP_TYPE} = this.state
        return (
            <div className="qiye_wechat-login">
                {CORP_TYPE!=="2" && <div className="qiye_wechat-code">
                    <div className="imgCont">
                        <img className='qiyeLogo' src={`${window.media_domain}/logo.png`} alt=""/>
                        <div className="convert">
                            <img src={convert} alt=""/>
                        </div>
                        <img src={qiyeweixin} alt=""/>
                    </div>
                    <button className="qiyeBtn">
                        <a rel="noreferrer" target="_blank" href={window.rootDirectroy +"/qyweixin/workweixin"}>{React.language('signin.qrcode')}</a>
                    </button>
                </div>}
                {CORP_TYPE==="2" && <div className="qiye_wechat_type">
                    <a rel="noreferrer" target="_blank" className="wework-member-link" href={window.rootDirectroy +"/ziqywx/sm_qyweixin"}>
                        <div className="wrapper">
                            <div className="wework-icon member-icon"></div>
                        </div>
                        <div className="text">{React.language('account.signin.wework.member')}</div>
                    </a>
                    <a rel="noreferrer" target="_blank" className="wework-admin-link" href={window.rootDirectroy +"/ziqywx/sm_admin_qyweixin"}>
                        <div className="wrapper">
                            <div className="wework-icon admin-icon"></div>
                        </div>
                        <div className="text">{React.language('account.signin.wework.admin')}</div>
                    </a>
                </div>}
                <div className="qiyeTip">
                    <div className="topTip">
                        {React.language('account.signin.wechatOpenTip')}
                    </div>
                    <div className="buttonTip">
                        <a rel="noreferrer" target="_blank" href={window.rootDirectroy +"/qyweixin/qywxregshow"}>{React.language('account.signin.corpOpen')}</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default LoginWorkWechatCode;